import { animate, inView } from "motion";

function walkscore() {
	let walkscore = document.querySelector(".walk-bike-score__item--walk .walk-bike-score__score");
	if (!walkscore) return;

	let walkscore_score = walkscore.dataset.score;
	inView(walkscore, () => {
		animate((progress) => {
			walkscore.innerHTML = Math.floor(progress * walkscore_score);
		}, {
			duration: 3,
			delay: 0
		});
	});
}


function bikescore() {
	let bikescore = document.querySelector(".walk-bike-score__item--bike .walk-bike-score__score");
	if (!bikescore) return;

	let bikescore_score = bikescore.dataset.score;
	inView(bikescore, () => {
		animate((progress) => {
			bikescore.innerHTML = Math.floor(progress * bikescore_score);
		}, {
			duration: 3,
			delay: 1
		});
	});
}

walkscore();
bikescore();
